import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import LoansAnalytics from '@/components/loans/LoansAnalytics';
import LoansRecords from '@/components/loans/LoansRecords';

export default function Loans() {
  return (
    <div className="space-y-6 animate-fade-in px-4 sm:px-6 lg:px-8 pt-6">
      <div className="mb-8">
        <h1 className="text-4xl font-semibold tracking-tight mb-2">Advances</h1>
        <p className="text-muted-foreground">Manage driver advances and repayment schedules.</p>
      </div>

      <Tabs defaultValue="analytics" className="space-y-6">
        <TabsList>
          <TabsTrigger value="analytics">Analytics</TabsTrigger>
          <TabsTrigger value="records">Records</TabsTrigger>
        </TabsList>

        <TabsContent value="analytics">
          <LoansAnalytics />
        </TabsContent>

        <TabsContent value="records">
          <LoansRecords />
        </TabsContent>
      </Tabs>
    </div>
  );
}
